import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {HodnotenieDetail} from '../model/HodnotenieDetail';
import {Message} from '../model/message';
import {HodnotenieSS} from '../model/HodnotenieSS';

@Component({
  selector: 'app-hodnotenie-detail',
  templateUrl: './hodnotenie-detail.component.html',
  styleUrls: ['./hodnotenie-detail.component.css']
})
export class HodnotenieDetailComponent implements OnInit {
  public title: string;
  public hodnotenie: HodnotenieDetail = new HodnotenieDetail();
  public hodnotenieSS: HodnotenieSS = new HodnotenieSS();

  constructor(
    public dialogRef: MatDialogRef<HodnotenieDetailComponent>,
    private http: HttpClient,
    private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public data: {message: Message},
  ) { }

  ngOnInit(): void
  {
    const url = '/ais/rest/portal/student-predmety/hodnotenie-detail-message/' + this.data.message.id;

    this.http.get<any>(url)
        .subscribe({
            next: (data) => {
              if (data.type === 'SS') {
                this.hodnotenieSS = data;
              }
              else {
                this.hodnotenie = data;
              }
            },
            error: (error) => {
              this.appService.openErrorDialog(error.error.message);
            }
        });
  }

}
